// Module
var code = "<iframe class=\"collabora-online-iframe\" allow=\"clipboard-read *; clipboard-write *; fullscreen\" ng-src=\"{{ $ctrl.collaboraOnlineSource }}\"> </iframe>";
// Exports
export default code;